class ModalZoom extends HTMLElement {
  static get observedAttributes() {
    return ['is-visible'];
  }

  constructor() {
    super();

    this.productImagesContainer = this.querySelector('[slot="body"]').querySelector('.js-product-media-images');
    this.productImages = this.productImagesContainer.childNodes;
    this.productImageThumbnails = this.querySelector('[slot="body"]').querySelector('.js-product-media-thumbnails').childNodes;
    this.buttonType = this.dataset.buttonType || false;
    this.modalName = this.dataset.modalName || false;
    this.activeMediaIndex = null;
    this.activeMedia = null;
    this.activeMediaThumbnail = null;

    // Navigate to previous/next image on scroll variables
    this.lastScrollTopPosition = 0
    this.scrollTimer = -1;
    this.scrollCount = 0;
  }

  get isVisible() {
    return this.hasAttribute('is-visible');
  }

  set isVisible(value) {
    this[value ? 'setAttribute' : 'removeAttribute']('is-visible', '')
  }

  connectedCallback() {
    this._render();
    this._attachEventHandlers();
  }

  attributeChangedCallback(name, oldValue, newValue) {
    if (name === 'is-visible' && this.shadowRoot) {
      newValue === null ? this.close() : this.open();
    }
  }

  open() {
    this.shadowRoot.querySelector('.wrapper').classList.add('is-visible');
    document.body.classList.add('overflow-hidden')
    this.classList.remove('visibility-hidden');
    this.classList.add('active');
    trapFocus(this, null, this.shadowRoot);
  }

  close() {
    this.shadowRoot.querySelector('.wrapper').classList.remove('is-visible');
    document.body.classList.remove('overflow-hidden');
    this.lastScrollTopPosition = 0
    this.scrollTimer = -1;
    this.classList.add('visibility-hidden');
    this.classList.remove('active');
    this.hideActiveMedia();
    removeTrapFocus();
  }

  _render() {
    let wrapperClass = this.isVisible ? 'wrapper is-visible' : 'wrapper'
    const shadowRoot = this.attachShadow({mode: 'open'});
    shadowRoot.innerHTML = `
      <style>
        .wrapper {
          position: fixed;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          opacity: 0;
          visibility: hidden;
          transform: scale(1.1);
          transition: visibility 0s linear .25s,opacity .25s 0s,transform .25s;
          z-index: 100;
          overflow-y: scroll;
        }
        .is-visible {
          opacity: 1;
          visibility: visible;
          transform: scale(1);
          transition: visibility 0s linear 0s,opacity .25s 0s,transform .25s;
        }
        .modal {
          position: absolute;
          top: 0;
          left: 0;
          overflow: auto;
        }
        .icon.close {
          display: block;
          position: fixed;
          top: 35px;
          right: 0;
          height: 17px;
          width: 17px;
          cursor: pointer;
          margin: 50px;
          padding: 20px;
          background-color: var(--color-reverse);
          border-radius: 50%;
          z-index: 1;
        }
        .content {
          padding: 30px 0;
        }
        ::slotted([slot="footer"]) {
          width: calc(100% - 20px);
        }
      </style>

      <div class='${wrapperClass}'>
        <aside class='modal' role="dialog">
          <span class="icon close" aria-label="Close" tabindex="0">
            <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" role="presentation" class="icon icon-close icon-remove" fill="none" viewBox="0 0 18 17">
              <path d="M.865 15.978a.5.5 0 00.707.707l7.433-7.431 7.579 7.282a.501.501 0 00.846-.37.5.5 0 00-.153-.351L9.712 8.546l7.417-7.416a.5.5 0 10-.707-.708L8.991 7.853 1.413.573a.5.5 0 10-.693.72l7.563 7.268-7.418 7.417z" fill="currentColor">
            </svg>
          </span>
          <slot name="body"></slot>
        </aside>
      </div>`;
  }

  _attachEventHandlers() {
    ['click', 'keydown'].forEach(evt => {
      this.shadowRoot.querySelector(['.close']).addEventListener(evt, e => {
        if (e.code?.toLowerCase() === 'enter' || evt === 'click') this.close()
      })
    })

    document.addEventListener('open-modal', e => {
      if (this.modalName === e.detail.modal_name) this.open()
      if (e.detail.payload) {
        this.setMediaDetails(e.detail.payload)
        this.showActiveMedia()
      }
    })

    document.addEventListener('close-modal', e => {
      if (this.modalName === e.detail.modal_name) this.close()
    })

    this.productImages.forEach(el => {
      el.addEventListener('click', () => {
        this.close()
        el.removeAttribute('style');
      })
    })

    this.productImageThumbnails.forEach(el => {
      el.addEventListener('click', (e) => {
        this.setNewActiveMedia(e.target.dataset.indexNumber - 1)
      })
    })
  }

  setMediaDetails(id) {
    this.activeMediaIndex = id.slice(-1) - 1
    this.activeMedia = this.querySelector(`.${id}`)
    this.activeMediaThumbnail = this.querySelector(`.js-pagination-dot--${id.slice(-1)}`)
  }

  setNewActiveMedia(idx) {
    this.activeMediaIndex = idx
    this.activeMedia = this.productImages[this.activeMediaIndex]
    this.activeMediaThumbnail = this.productImageThumbnails[this.activeMediaIndex]
    this.hideActiveMedia()
    this.showActiveMedia()
  }

  showActiveMedia() {
    this.setScrollability(true)
    this.activeMedia.scrollIntoView({ block: "center"})
    this.activeMedia.classList.add('active')
    this.activeMediaThumbnail.classList.add('active')
  }

  hideActiveMedia() {
    this.productImages.forEach(el => {
      el.classList.remove('active')
    })

    this.productImageThumbnails.forEach(el => {
      el.classList.remove('active')
    })

    this.scrollCount = 0;
  }

  setScrollability(state) {
    this.productImagesContainer.style.overflowY = state ? '' : 'hidden'
  }

  setScrollTimer(idx) {
    this.scrollTimer = setTimeout(this.setNewActiveMedia.bind(this, idx), 100);
  }
}
window.customElements.define('hh-modal-zoom', ModalZoom);
